import React from "react";
import { useHistory } from "react-router-dom";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import GroupIcon from "@mui/icons-material/Group";
import Swal from "sweetalert2";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import HandshakeIcon from "@mui/icons-material/Handshake";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import TaskIcon from "@mui/icons-material/Task";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";

export const ChartGestionCobranza3 = ({
  data,
  ejercicio,
  periodo,
  sucursales,
}) => {
  const history = useHistory();

  const handleClickObjetivoTotal = (
    ejercicio,
    periodo,
    tipo_grafica,
    tipo_cartera,
    estado_cartera,
    responsable_cobranza,
    nombre,
    cartera,
    categoria,
    dato
  ) => {
    if (dato <= 0) {
      Swal.fire({
        icon: "warning",
        title: "PROYECCION DE RECUPERACION",
        text: "No hay datos para mostrar en este mes.",
        confirmButtonText: "Entendido",
      });
      return;
    }

    history.push("/Creditoycobranza/ReporteObjetivoTotal", {
      ejercicio,
      periodo,
      tipo_grafica,
      tipo_cartera,
      estado_cartera,
      responsable_cobranza,
      nombre,
      cartera,
      categoria,
    });
  };

  const formatmiles = (number) => {
    if (number <= 0) {
      number = 0;
    }
    return Math.floor((number ?? 0) / 1000).toLocaleString("en-US");
  };

  // console.log(data)

  const porVencer = data.find((item) => item.estado === "P");
  const vencido = data.find((item) => item.estado === "V");
  return (
    <table className="objetivo-total-table">
      <thead>
        <tr className="objetivo-total-item-title">
          <th></th>
          <th></th>
          <th>Total</th>
          <th>Clientes</th>
        </tr>
      </thead>
      <tbody>
        <tr
          className="objetivo-total-item-info"
          onClick={() =>
            history.push("/Creditoycobranza/GestionClientes", {
              permisos: sucursales,
              filtro: "C",
            })
          }
        >
          <td>
            <AttachMoneyIcon /> <span>Total</span>
          </td>
          <td></td>
          <td>
            {"$" +
              formatmiles(
                (porVencer?.total_objetivo ?? 0) +
                  (vencido?.total_objetivo ?? 0)
              )}
          </td>
          <td>
            {(porVencer?.clientes_objetivo ?? 0) +
              (vencido?.clientes_objetivo ?? 0)}
          </td>
        </tr>

        <tr
          className="objetivo-total-item-info"
          onClick={() =>
            history.push("/Creditoycobranza/GestionClientes", {
              permisos: sucursales,
              filtro: "R",
            })
          }
        >
          <td>
            <AssuredWorkloadIcon />
            <span> Recuperado</span>
          </td>
          <td></td>
          <td>
            {"$" +
              formatmiles(
                (porVencer?.recuperado ?? 0) + (vencido?.recuperado ?? 0)
              )}
          </td>
          <td>
            {(porVencer?.clientes_recuperados ?? 0) +
              (vencido?.clientes_recuperados ?? 0)}
          </td>
        </tr>

        <tr
          className="objetivo-total-item-info"
          onClick={() =>
            history.push("/Creditoycobranza/GestionClientes", {
              permisos: sucursales,
              filtro: "G",
            })
          }
        >
          <td>
            <TaskIcon /> <span>Gestionado</span>
          </td>
          <td></td>
          <td>
            {"$" +
              formatmiles(
                (porVencer?.gestionado ?? 0) + (vencido?.gestionado ?? 0)
              )}
          </td>
          <td>
            {(porVencer?.clientes_gestionados ?? 0) +
              (vencido?.clientes_gestionados ?? 0)}
          </td>
        </tr>

        <tr
          className="objetivo-total-item-info"
          onClick={() =>
            history.push("/Creditoycobranza/GestionClientes", {
              permisos: sucursales,
              filtro: "G",
            })
          }
        >
          <td style={{ paddingLeft: "40px" }}>
            <CheckIcon /> <span>Pagado</span>
          </td>
          <td></td>
          <td>
            {"$" +
              formatmiles(
                (porVencer?.gestionado_pagado ?? 0) +
                  (vencido?.gestionado_pagado ?? 0)
              )}
          </td>
          <td>
            {(porVencer?.clientes_gestionados_pagados ?? 0) +
              (vencido?.clientes_gestionados_pagados ?? 0)}
          </td>
        </tr>

        <tr
          className="objetivo-total-item-info"
          onClick={() =>
            history.push("/Creditoycobranza/GestionClientes", {
              permisos: sucursales,
              filtro: "G",
            })
          }
        >
          <td style={{ paddingLeft: "40px" }}>
            <ClearIcon /> <span>No Pagado</span>
          </td>
          <td></td>
          <td>
            {"$" +
              formatmiles(
                (porVencer?.gestionado_nopagado ?? 0) +
                  (vencido?.gestionado_nopagado ?? 0)
              )}
          </td>
          <td>
            {(porVencer?.clientes_gestionados_nopagados ?? 0) +
              (vencido?.clientes_gestionados_nopagados ?? 0)}
          </td>
        </tr>

        <tr
          className="objetivo-total-item-info"
          onClick={() =>
            history.push("/Creditoycobranza/GestionClientes", {
              permisos: sucursales,
              filtro: "V",
            })
          }
        >
          <td>
            <HandshakeIcon /> <span>Conveniado</span>
          </td>
          <td></td>
          <td>
            {"$" +
              formatmiles(
                (porVencer?.conveniado ?? 0) + (vencido?.conveniado ?? 0)
              )}
          </td>
          <td>
            {(porVencer?.clientes_conveniados ?? 0) +
              (vencido?.clientes_conveniados ?? 0)}
          </td>
        </tr>

        <tr
          className="objetivo-total-item-info"
          onClick={() =>
            history.push("/Creditoycobranza/GestionClientes", {
              permisos: sucursales,
              filtro: "S",
            })
          }
        >
          <td>
            <HourglassBottomIcon /> <span>Sin Gestión</span>
          </td>
          <td></td>
          <td>
            {"$" +
              formatmiles(
                (porVencer?.pendiente ?? 0) + (vencido?.pendiente ?? 0)
              )}
          </td>
          <td>
            {(porVencer?.clientes_pendientes ?? 0) +
              (vencido?.clientes_pendientes ?? 0)}
          </td>
        </tr>
      </tbody>
    </table>
  );
};
